import { combineReducers, Action } from 'redux'
import appActionsReducer from './app_action_reducers/appActionsReducer'
import dataActionsReducer from './data_action_reducers/dataActionsReducer'
import { ThunkAction } from 'redux-thunk';

const rootReducer = combineReducers({
    app: appActionsReducer,
    data: dataActionsReducer
})

export type TRootState = ReturnType<typeof rootReducer>;
export type AppThunk = ThunkAction<void, TRootState, null, Action<string>>;

export default rootReducer;